import React from "react";
import PropTypes from "prop-types";
import { Select } from "@opendate-app/setlist";

const NOTIFICATIONS_OFF_HINT = "Has inbound notifications turned off";

const EmailAlertsEditor = ({ teamMembers = [], value = [], onChange }) => {
  const options = teamMembers.map(({ id, name, email, notificationsOff }) => ({
    value: id,
    label: name,
    supportingText: notificationsOff ? NOTIFICATIONS_OFF_HINT : email,
    disabled: notificationsOff,
  }));

  return (
    <Select
      id="signup-form-alert-recipients"
      label="Notify"
      placeholder="Add team member…"
      multiple
      searchable
      options={options}
      value={value}
      onChange={(ids) => onChange(ids || [])}
    />
  );
};

EmailAlertsEditor.propTypes = {
  teamMembers: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string,
    email: PropTypes.string,
    notificationsOff: PropTypes.bool,
  })),
  value: PropTypes.arrayOf(PropTypes.number),
  onChange: PropTypes.func.isRequired,
};

export default EmailAlertsEditor;
